<template>
  <div class="hero is-fullheight is-primary">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-narrow">
            <!-- Content will be placed here -->
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* ============
 * Minimal Layout
 * ============
 *
 * Used for the register and login pages.
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

export default {
  /**
   * The name of the layout.
   */
  name: "MinimalLayout"
}
</script>

<style lang="sass" scoped>
.container
  margin-top: 2rem
</style>
